import CurrencyInr from "@/components/common/currency-inr";
import { selectProduct } from "@/store/slices/product";

import React from "react";
import { useSelector } from "react-redux";
import styles from "./price.module.scss";

const ProductDetailsPrice = () => {
  const productState = useSelector(selectProduct);

  if (!productState.data) {
    return <></>;
  }

  return (
    <>
   
      <div
        className={`${styles.product_price} product-info-sku-variant`}
        data-sku={productState?.data?.sku}
        data-variant-id={productState?.selectedPrice?.id}
      >
        <p className={styles.new_price}>
          {!!productState.selectedPrice && (
            <span>
              <CurrencyInr
                value={
                  productState.selectedPrice?.discount
                    ? productState.selectedPrice?.discount.total
                    : productState.selectedPrice?.total
                }
              />
            </span>
          )}
        </p>

        <div className={styles.price_cross}>
          {!!productState.selectedPrice?.discount && (
            <p className={styles.last_price}>
              <span>
                <CurrencyInr value={productState.selectedPrice.total} />
              </span>
              {/* <span className={styles.save_rupess}>
              You save -{" "}
              <CurrencyInr
                value={
                  productState.selectedPrice.total -
                  productState.selectedPrice.discount.total
                }
              />
            </span> */}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductDetailsPrice;
